import React, { useState, useEffect, useRef } from "react";

import iconBG from "../../../../../revampComponents/Atom/Icons/iconBG.svg";
import iconEdit from "../../../../../revampComponents/Atom/Icons/iconEdit.svg";
import iconDelete from "../../../../../revampComponents/Atom/Icons/iconDelete.svg";
import LoadingSpinner from "../../../../../revampComponents/Atom/Loading";
import ImageModal from "../../../../../revampComponents/ImageUploader/CropImageModal";

import UploadImageButton from "../../../../../revampComponents/ImageUploader/uploadImageButton";
import RouteModal from "../../../../../revampComponents/Atom/Modals/RouteModal";
import TippyIcon from "../../../../../revampComponents/Atom/TippyIcon";
import { errorToaster } from "../../../../../reusable/common";
import FileUpload from "../../../../../revampComponents/Molecule/Inputs/FileUpload/FileUpload";
import customCardImage from "../../../../../assets/img/common/bg.svg";

const FavIcon = ({ iconUrl, onIconChange, error = false, isRestricted = false }) => {
	//UseState for edit image
	const [editImage, setEditImage] = useState(false);

	//For Image
	const [uploadedImage, setuploadedImage] = useState("");
	const [imageModal, setImageModal] = useState(false);
	const [imageRef, setImageRef] = useState("");
	const [imageInput, setImageInput] = useState("");
	const [previewLogoUrl, setPreviewLogoUrl] = useState("");
	const imageModuleNo = 12;
	const componentDidMount = useRef(false);

	useEffect(() => {
		//On edit poster image and organiser image should be shown in preview
		if (iconUrl) {
			setPreviewLogoUrl(iconUrl);
		}
	}, [iconUrl]);

	const imageHandler = (imageUrl, previewUrl) => {
		onIconChange(imageUrl);
		setPreviewLogoUrl(previewUrl);
	};

	// function to open image model
	const openImageModal = e => {
		if (e.target.files[0].size < 614400) {
			setImageRef(e.target);
			setImageModal(true);
			setuploadedImage(e.target);
			setImageInput(e.target.name);
			setEditImage(true);
		} else {
			errorToaster("Image size is greater than 600 KB. It should be less than 600KB.");
		}
	};

	// function to edit image model
	const EditImageModal = () => {
		setImageModal(true);
		setImageInput("fav_icon");
		setImageRef(uploadedImage);
	};
	//function to close image model on click on cancel button
	const closeImageModal = () => {
		setImageRef("");
		setImageModal(false);
	};

	//function used to remove selected image
	const removeSelectedImage = () => {
		onIconChange("");
		setPreviewLogoUrl("");
	};

	return (
		<div className="">
			<ImageModal
				show={imageModal}
				imageHandler={imageHandler}
				closeModal={closeImageModal}
				imageHandlerFunc={imageHandler}
				moduleNo={imageModuleNo}
				imageRef={imageRef}
			/>

			{!previewLogoUrl && (
				<div className="">
					<div className="customCard">
						<FileUpload
							onChange={imageHandler}
							moduleNumber={imageModuleNo}
							aspect={1 / 1}
						>
							<UploadImageButton
								size="110px"
								height="110px"
								id="fav_icon"
								uploadText={`Add Logo`}
							/>
						</FileUpload>
					</div>
				</div>
			)}

			{error && (
				<p className="text-danger text-right" style={{ marginRight: "10%" }}>
					{error}
				</p>
			)}
			{previewLogoUrl && (
				<div className={isRestricted ? " disable-restricted-elements " : ""}>
					<div>
						<div className="d-inline-block" style={{ position: "relative" }}>
							<img
								className="uploadButtonClass"
								alt="Crop"
								style={{
									// padding: "2px",
									maxWidth: "110px",
									maxHeight: "110px",
									width: "110px",
									height: "110px",
									// border: "2px solid #572148",
									borderRadius: "7px"
								}}
								src={previewLogoUrl}
							/>
							{editImage == true && (
								<span
									onClick={EditImageModal}
									style={{
										position: "absolute",
										top: "-3%",
										right: "-2%"
									}}
								>
									<TippyIcon content="Edit">
										<img
											style={{
												backgroundImage: `url(${iconBG})`,
												backgroundPosition: "center",
												backgroundSize: "cover",
												backgroundRepeat: "no-repeat",
												padding: "3.5px 3px",
												height: "23px",
												width: "23px",
												cursor: "pointer"
											}}
											src={iconEdit}
										/>
									</TippyIcon>
								</span>
							)}

							<span
								onClick={removeSelectedImage}
								style={
									editImage == false
										? {
												position: "absolute",
												bottom: "-3%",
												right: "-3%"
											}
										: {
												position: "absolute",
												bottom: "-3%",
												right: "-3%"
											}
								}
							>
								<TippyIcon content="Delete">
									<img
										style={{
											backgroundImage: `url(${iconBG})`,
											backgroundPosition: "center",
											backgroundSize: "cover",
											backgroundRepeat: "no-repeat",
											padding: "3.5px 3px",
											height: "22px",
											width: "22px",
											cursor: "pointer"
										}}
										src={iconDelete}
									/>
								</TippyIcon>
							</span>
						</div>
					</div>
				</div>
			)}

			<style jsx>{`
				.uploadButtonClass:hover * {
					// opacity: 0.6;
				}

				.ReactCrop .ReactCrop__crop-selection {
					border-radius: 2px;
				}

				.uploadButtonClass {
					box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
					background-image: url(${customCardImage});
					background-size: cover;
					background-repeat: no-repeat;
				}

				.uploadButtonClass:hover {
					background-color: rgb(0 0 0 / 11%) !important;
				}
			`}</style>
		</div>
	);
};

export default FavIcon;
